import { Button, Intent, Tooltip } from "@focus/focusUI";
import { useMemo } from "react";
import { ROLES, useRoles } from "../../hooks/useRoles";
import { useUserController } from "../../hooks/useUserController";
import type { User } from "../../types/users";

interface EnableDisableButtonProps {
  user?: User;
  text?: string;
  intent?: Intent;
  disabled?: boolean;
}

export const EnableDisableButton = ({
  user,
  text,
  intent,
  disabled,
}: EnableDisableButtonProps) => {
  const { organizations, enableUser, disableUser } = useUserController();
  const { roles } = useRoles();

  const canEdit = useMemo(() => {
    if (roles.includes(ROLES.ADMIN)) return true;
    if (!roles.includes(ROLES.ORG_ADMIN)) return false;

    return (
      user?.organizations?.some((org) => organizations.includes(org)) ?? false
    );
  }, [roles, organizations, user?.organizations]);

  if (!canEdit) return null;

  return (
    <Tooltip
      content={
        text ? undefined : user?.enabled ? "Disable user" : "Enable user"
      }
    >
      <Button
        intent={intent}
        icon={user?.enabled ? "disable" : "tick"}
        minimal={!intent}
        text={text}
        onClick={() => {
          if (user?.enabled) return disableUser(user?.id);
          return enableUser(user?.id);
        }}
        disabled={disabled}
      />
    </Tooltip>
  );
};
